// third party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";

// ==============================|| SLICE - DOCUMENTS ||============================== //

const initialState = {
  error: null,
  documents: [],
  rallyDocuments: [],
  loading: false,
};

const slice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    // SET LOADING
    setLoading(state, action) {
      state.loading = action.payload;
    },

    // GET DOCUMENTS
    getDocumentsSuccess(state, action) {
      state.documents = action.payload;
      state.loading = false;
    },

    // UPLOAD DOCUMENT
    uploadDocumentSuccess(state, action) {
      state.documents.unshift(action.payload);
      state.loading = false;
    },

    // DELETE DOCUMENT
    deleteDocumentSuccess(state, action) {
      state.documents = state.documents.filter(
        (doc) => doc.id !== action.payload,
      );
      state.loading = false;
    },

    // GET RALLY DOCUMENTS
    getRallyDocumentsSuccess(state, action) {
      state.rallyDocuments = action.payload;
      state.loading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// ==============================|| SLICE - DOCUMENTS ACTIONS ||============================== //

export function getDocuments() {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.get("/admin/documents");
      dispatch(slice.actions.getDocumentsSuccess(response.data.documents));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRallyOfficerDocuments() {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.get("/rally-officer/documents");
      dispatch(slice.actions.getDocumentsSuccess(response.data.documents));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function uploadDocument(file, rallyId = null) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const formData = new FormData();
      formData.append("file", file);
      if (rallyId) {
        formData.append("rally_id", rallyId);
      }

      const response = await axios.post("/admin/documents", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch(slice.actions.uploadDocumentSuccess(response.data.document));
      return response.data.document;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteDocument(docId) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      await axios.delete(`/admin/documents/${docId}`);
      dispatch(slice.actions.deleteDocumentSuccess(docId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getDownloadUrl(docId, isRallyOfficer = false) {
  return async () => {
    try {
      const endpoint = isRallyOfficer
        ? `/rally-officer/documents/${docId}/download-url`
        : `/admin/documents/${docId}/download-url`;
      const response = await axios.get(endpoint);
      return response.data.download_url;
    } catch (error) {
      throw error;
    }
  };
}

export function getRallyDocuments(rallyId) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.get(
        `/rally-officer/rallies/${rallyId}/documents`,
      );
      dispatch(slice.actions.getRallyDocumentsSuccess(response.data.documents));
      return response.data.documents;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
